<template>
    <div>
        <div class="d-flex justify-content-between align-items-baseline mb-3">
            <!-- <h5 class="mb-0">{{ title }}</h5> -->
            <div class="w-100 d-flex gap-2 align-items-center">
                <b-button size="sm" variant="gray-primary" @click="handleSelectAllClick">Select All</b-button>
                <b-button size="sm" variant="gray-primary" @click="handleSelectNoneClick">None</b-button>
            </div>
        </div>
        <div class="overflow-auto" style="max-height: 400px;">  <!-- wrapper for all the checkbox items - put a max height on this -->
            <div 
                v-for="opt in options" 
                :key="opt[valueField]" 
                class="w-100 d-flex align-items-center gap-2 mb-2 filter-checkbox-wrapper"
            >
                <Checkbox 
                    v-model="localSelectedValues"
                    :id="opt[valueField]" 
                    name="selectedVendors" 
                    :value="opt[valueField]" 
                    @change="emitUpdate"
                ></Checkbox>
                <label 
                    :for="opt[valueField]" 
                    class="mb-0 d-flex gap-1 align-items-center justify-content-between"
                >
                    <div>{{opt[labelField]}}</div>
                    <b-link 
                        class="ml-2 checkbox-only-button font-size-70 text-decoration-none font-weight-500 text-uppercase" 
                        variant="link"
                        @click="handleSelectOnly(opt[valueField])"
                    >{{ isOnlySelection(opt[valueField]) ? 'All' : 'Only' }}</b-link>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
//import { errorHandling } from '../../js/custom-vue-mixins';
import Checkbox from 'primevue/checkbox';

export default {
    name: 'AnalyticsSelectFilter',
    components: {
        Checkbox,
    },
    mixins: [
    ],
    props: {
        title: {
            type: String,
            default: '',
        },
        options: {  // should have { label, value } - or specify in labelField, valueField
            type: Array,
            required: true,
        },
        valueField: {
            type: String,
            default: 'value',
        },
        labelField: {
            type: String,
            default: 'label',
        },
        // LATER - add prop to handle pre-selections or parent selections - will need watcher on it too I think
    },
    data: function() {
        return {
            localSelectedValues: [],  
        }
    },
    computed: {

    },
    mounted() {
        // one-time stuff -- preselect everything! (all the time?) then tell parent we are ready
        this.selectAll();
        this.$emit('ready', this.localSelectedValues);
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        handleSelectOnly(onlySelectedValue) {
            // pass in the name of a data attributes that holds the filtered things ('selectedVendor')
            // and the id/value we should add to that
            // this ALSO gets called to 'unset' the ONLY filter, to select ALL again
            // so check if this selectedValue is already the only selection... if so, then select all on the filter
            if (this.isOnlySelection(onlySelectedValue)) {
                // if here, then selectedValue was already the ONLY selection, so we will select ALL now
                // do this once you break filter into a component!
                this.reset();
            } else {
                this.localSelectedValues = [ onlySelectedValue ];
                this.emitUpdate();
            }
        },
        isOnlySelection(value) {
            return (this.localSelectedValues.length === 1) && this.localSelectedValues.includes(value);
        },
        handleSelectAllClick() {
            this.selectAll();
            this.emitReset();
        },
        handleSelectNoneClick() {
            this.localSelectedValues = [];
            this.emitUpdate();
        },
        selectAll() {  // does not emit to parent - let caller do that since its not always needed (like in mounted?)
            this.localSelectedValues = this.options.map(opt => opt[this.valueField]);
        },
        reset(skipUpdate = false) {  
            // call with skipUpdate=true when calling this on many of them together from parent
            // but remember, the parent will still have the latest selections -- so you have to manually clear those in the parent!
            //console.log(`reset from filter ${this.title}`);
            this.selectAll();
            if (!skipUpdate) {
                this.emitReset();
            }
        },
        emitUpdate() {
            // update parent
            this.$emit('updated', [...this.localSelectedValues]);
        },
        emitReset() {
            // this is a special case where we'll tell parent to just remove the filter completely, rather than keeping it there with all selected (performance)
            this.$emit('reset');  // no payload needed
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-checkbox-wrapper {
    .checkbox-only-button {
        //display: none;
        visibility: hidden;
    }
    &:hover {
        .checkbox-only-button {
            //display: inline;
            visibility: visible;
        }
    }
}
</style>